import {
  depotGetDepotList,
  depotAddDepot,
  depotUpdateDepot,
  depotDeleteDepot
} from '@/api/api'

const state = {
  depotList: [],
  depotTotal: 0
}

const getters = {
  depotList: state => state.depotList,
  depotTotal: state => state.depotTotal
}

const actions = {
  loadDepotList ({ dispatch }, parm) {
    return depotGetDepotList(parm).then((data) => {
      data.forEach((item) => {
        item.statusText = item.status === '1' ? '在用' : '停用'
        let oilTypeList = []
        item.depotOilTypes.forEach((item) => {
          oilTypeList.push((item.oilTypeId))
        })
        item.oilTypeList = oilTypeList
      })
      dispatch('setDepotList', data)
    })
  },
  addDepot ({ commit }, parm) {
    return depotAddDepot(parm)
  },
  updateDepot ({ commit }, parm) {
    return depotUpdateDepot(parm)
  },
  delDepot ({ commit }, gasId) {
    return depotDeleteDepot(gasId)
  },
  setDepotList ({ commit }, data) {
    commit('setDepotList', data)
  },
  setDepotTotal ({ commit }, data) {
    commit('setDepotTotal', data)
  }
}

const mutations = {
  setDepotList (state, data) {
    state.depotList = data
  },
  setDepotTotal (state, data) {
    state.depotTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/depot.js